import Vue from '../vue/common/vue-common';
import PreBlackFriday from '../vue/components/pre-black-friday/PreBlackFriday.vue';

cr$.ready(function () {
    requestIdleCallback(() => new Vue(PreBlackFriday));
});
